import React from 'react';
import { Box } from '@mui/material';
import { InputField } from 'components/form';
import { formatPhoneInput } from 'formatters';
import { useFormContext, useWatch } from 'react-hook-form';
import { TestIds } from 'modules/sendCreditApplication/constants';
import { SendOcaLinkSendMethods } from '@trnsact/trnsact-shared-types';

import { SendApplicationFormValues } from '../../types';

export const ContactDetailsSection = () => {
  const { control } = useFormContext<SendApplicationFormValues>();

  const sendMethod = useWatch({
    control,
    name: 'sendMethod',
  });

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', paddingTop: '12px' }}>
      <InputField
        label="First Name"
        control={control}
        name="contactDetails.firstName"
        inputProps={{ variant: 'outlined', required: true }}
      />

      <InputField
        label="Last Name"
        control={control}
        name="contactDetails.lastName"
        inputProps={{ variant: 'outlined', required: true }}
      />

      <InputField
        label="Mobile Phone"
        control={control}
        name="contactDetails.mobilePhone"
        formatter={formatPhoneInput}
        inputProps={{
          variant: 'outlined',
          required: [SendOcaLinkSendMethods.Text, SendOcaLinkSendMethods.TextAndEmail].includes(sendMethod),
          slotProps: { input: { inputProps: { 'data-testid': TestIds.MobilePhoneInput } } },
        }}
      />

      <InputField
        label="Business Name"
        control={control}
        name="contactDetails.businessName"
        inputProps={{ variant: 'outlined', sx: { gridColumn: 'span 2' } }}
      />

      <InputField
        label="Email"
        control={control}
        name="contactDetails.email"
        inputProps={{
          variant: 'outlined',
          required: [SendOcaLinkSendMethods.Email, SendOcaLinkSendMethods.TextAndEmail].includes(sendMethod),
          slotProps: { input: { inputProps: { 'data-testid': TestIds.EmailInput } } },
        }}
      />
    </Box>
  );
};
